import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppDisclosureOfficer = () => {
    const navLinks = [
        {destination: "disclosures", label: "Disclosures"},
        {destination: "charts", label: "Charts"},
        {destination: "experts", label: "Experts"},
        {destination: "feed", label: "Feeds"},
        {destination: "kb", label: "KB"},
        {destination: "workflow", label: "Workflow"},
        HELP_NAV_LINK,
    ];

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Outlet/>
        </Stack>
    );
};

export default AppDisclosureOfficer;
